'use strict'

const state = {
  isFetching: false,
  error: null,
  data: {}
}

export default {
  state
}
